import { nanoid } from "nanoid";

// https://zelark.github.io/nano-id-cc/
// 8 characters: 2M IDs before a 1% chance of collision
// 9: 19M IDs before a 1% chance of collision
// 10: 152M IDs before a 1% chance of collision
// 11: 1B IDs before a 1% chance of collision
// 12: 9B IDs before a 1% chance of collision

export const generateRoundId = () => `r-${nanoid(8)}`;
export const generateActionId = () => `a-${nanoid(12)}`;
export const generateProposalId = () => `p-${nanoid(10)}`;
export const generateProposalFieldId = () => `field-${nanoid(10)}`;
export const generateProposalFormId = () => `form-${nanoid(10)}`;
export const generateClientId = () => `c-${nanoid(8)}`;
export const generateFunderId = () => `f-${nanoid(8)}`;
export const generateRecommenderId = () => `rec-${nanoid(8)}`;
export const generateUserId = () => `u-${nanoid(10)}`;
export const generatePublicUserAccessLogId = () => `pual-${nanoid(15)}`;
export const generateRoundMemberId = () => `rm-${nanoid(10)}`;

export const generateEvaluatorId = (
  evaluatorType: "recommender" | "funder",
) => {
  switch (evaluatorType) {
    case "recommender":
      return generateRecommenderId();
    case "funder":
      return generateFunderId();
    default:
      return `e-${nanoid(8)}`;
  }
};
